"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ramda = require("ramda");

var rofq = function rofq(q) {
  return (0, _ramda.omit)(['$or'], q);
};

var cnd2q = function cnd2q(obj, part) {
  return (0, _extends2.default)({}, obj, part);
};

var eand = function eand(q) {
  return q.$and ? q.$and : [];
};

var partsReducer = function partsReducer(sq, part) {
  return sq.$or ? cnd2q(rofq(sq), {
    $and: [{
      $or: sq.$or
    }, part].concat((0, _toConsumableArray2.default)(eand(sq)))
  }) : cnd2q(sq, part);
};
/**
 * Vraci bezpecne spojenou cast dotazu s jednou, nebo vice podminkami.
 *
 * @param {Object} query
 * @param {Object | Array<Object>} parts Jedna podminka, nebo pole podminek.
 * @returns {Object} Spojenou query spojenou s dalsimi podminkami.
 */


var mergePartWithQuery = function mergePartWithQuery(query, parts) {
  var sq = query || {};
  var fp = Array.isArray(parts) ? parts : [parts];
  return fp.reduce(partsReducer, sq);
};

var _default = mergePartWithQuery;
exports.default = _default;